import { HStack, StackProps } from '@chakra-ui/react'

import { createWidget } from '../widget-utils'
import { PageHeaderTagsRowParts } from './pageHeaderTagsRow.parts'

export type PageHeaderTagsRowWidgetProps = StackProps & {
  children?: React.ReactNode
  isLoading?: boolean
}

/** Collapses when tag/pill children render nothing (e.g. no related shipments). */
export const PageHeaderTagsRowWidget = ({
  children,
  isLoading,
  ...props
}: PageHeaderTagsRowWidgetProps) => {
  if (!PageHeaderTagsRowParts.hasVisibleChildren(children, isLoading)) {
    return null
  }

  return (
    <HStack gap="8px" alignItems="center" paddingTop="12px" {...props}>
      {children}
    </HStack>
  )
}

export const PageHeaderTagsRowWidgetDefinition = createWidget(
  PageHeaderTagsRowWidget,
  {
    type: 'PageHeaderTagsRow',
  },
)
